import React from "react";
import Navbar from "./components/Navbar";
import Route from "./utils/Route";
import Footer from "./components/Footer";
import { useLocation } from "react-router-dom";

import "./scss/app.scss";

const App = () => {
  const { pathname } = useLocation();
  return (
    <div className="app">
      {!pathname.startsWith("/newproject") ? <Navbar /> : ""}
      <div className="main">
        <Route />
      </div>

      {!pathname.startsWith("/newproject") ? <Footer /> : ""}
    </div>
  );
};

export default App;
